module.exports = __webpack_public_path__ + "img/defaultAva-w.d5f8def4.png";